import React from "react";
import { Link } from "react-router-dom";

interface IField {
    to: string;
    label: string;
    icon: React.ReactNode;
    selected?: boolean;
    onClick?: () => void;
}

export default function SideField({ to, icon, label, selected = false, onClick }: IField) {
    return (
        <Link
            to={to}
            onClick={onClick}
            aria-current={selected ? "page" : undefined}
            className={`relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary ${selected ? "bg-white/10 text-white" : "text-gray-400 hover:bg-white/5 hover:text-white"}`}
        >
            {
                selected ?
                    <span className="absolute left-0 top-2 bottom-2 w-[3px] rounded-r-full bg-secondary" />
                    : null
            }
            <span className={selected ? "text-secondary" : ""}>{icon}</span>
            <span className="truncate">{label}</span>
        </Link>
    )
}
